var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"autobookpro-page-content"},_vm._l((_vm.surveys),function(survey){return _c('div',{key:survey.id},[_c('p',[_vm._v("Order: "+_vm._s(survey.orderId))]),_c('p',[_vm._v("Review: "+_vm._s(survey.note))]),_c('p',[_vm._v("Rating: "+_vm._s(survey.rating))]),_c('p',[_vm._v("Submitted At: "+_vm._s(survey.createdAt))]),_c('br')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }